import { esES as coreES } from '@mui/material/locale';
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { esES } from '@mui/x-data-grid';
import breakpoints from '@fingo/lib/theme/breakpoints';
import getActiveRequestingPlatformFromEnv from '@fingo/lib/helpers/requesting-platform';
import themeStrategyProvider from './ThemeStrategyProvider';

const strategy = themeStrategyProvider.getStrategy(getActiveRequestingPlatformFromEnv());
const palette = strategy.getPalette();
const components = strategy.getComponents();
const typography = strategy.getTypography();
const branding = strategy.getBranding();

const theme = createTheme(
  {
    palette,
    breakpoints,
    typography,
    components,
    branding,
  },
  coreES,
  esES,
);

theme.typography.body2 = {
  ...theme.typography.body2,
  [theme.breakpoints.down('md')]: {
    fontSize: 10,
  },
};

export default responsiveFontSizes(theme);
